<!--
/**
 * Main component for webapp entry point
 *
 * @package ARS Webapp
 * @author René Schulze <schulze@thadeus-roth.de>
 */
 -->

<script setup>
    import { inject } from 'vue';
    import config from '?/Config';
    import emitter from '?/Composable/Events/Emitter';
    import Header from '?/Component/Webapp/Header';
    import Footer from '?/Component/Webapp/Footer';
    import Modal from '?/Component/Modal';
    import FlashMessage from '?/Component/FlashMessage';
    import repository from '?/Composable/Repository';
    import registerEvents from '?/Composable/Events/Webapp';
    import registerCustomEvents from '?/Composable/Events/CustomWebapp';

    // Initialization
    registerEvents();
    registerCustomEvents();

    if (repository.isAuthenticated()) {
        // @event user-is-authenticated
        emitter.emit('user-is-authenticated', repository.isAuthenticated());
    } else if (config.registrationlessLogin) {
        repository.registrationAnon()
            .then((response) => {
                // @event user-is-authenticated
                emitter.emit('user-is-authenticated', repository.isAuthenticated());
            })
            .catch((error) => {
                // @event user-is-not-authenticated
                emitter.emit('user-is-not-authenticated', repository.isAuthenticated());
            });
    } else {
        // @event user-is-not-authenticated
        emitter.emit('user-is-not-authenticated', repository.isAuthenticated());
    }
</script>

<template>
    <Header />
    <router-view id="content"
                 class="content"
                 tabindex="-1"
                 :aria-label="$t('webapp.content')"></router-view>
    <Footer />
    <Modal />
    <FlashMessage />
</template>
